import React from "react";
import { Row, Col } from "react-bootstrap";

function Header() {

    return (
        <>
            {/* <div style={{ height: "80px" }} >
                <div className={window.innerWidth > 700 ? "ps-5 pe-5 text-start" : "ps-3 pe-3 text-start"} style={{ position: "fixed", zIndex: 1, paddingTop: "10px", width: "100vw", borderBottom: "1px solid grey", backgroundColor: "white" }}>
                    <img className="mb-3" width="150" height="40" alt="" src="https://i0.wp.com/care24.co.in/wp-content/uploads/2022/07/care24-logo.png?fit=576%2C139&ssl=1"></img>

                    {window.innerWidth < 700 && <a href="tel:7314821589" style={{
                        float: 'right',
                        padding: "10px",
                        border: "none", color: "white",
                        backgroundColor: "#2b7dbd", borderRadius: "7px"
                    }}><svg xmlns="http://www.w3.org/2000/svg" style={{ height: "25px", color: "white", }} fill="currentColor" viewBox="0 0 512 512"><path d="M511.2 387l-23.25 100.8c-3.266 14.25-15.79 24.22-30.46 24.22C205.2 512 0 306.8 0 54.5c0-14.66 9.969-27.2 24.22-30.45l100.8-23.25C139.7-2.602 154.7 5.018 160.8 18.92l46.52 108.5c5.438 12.78 1.77 27.67-8.98 36.45L144.5 207.1c33.98 69.22 90.26 125.5 159.5 159.5l44.08-53.8c8.688-10.78 23.69-14.51 36.47-8.975l108.5 46.51C506.1 357.2 514.6 372.4 511.2 387z" /></svg>
                    </a>}
                    {window.innerWidth > 700 && <div style={{
                        float: 'right',
                        padding: "10px",
                        fontWeight: "bold",
                        fontSize: "19px",
                        width: window.innerWidth > 700 ? "395" : window.innerWidth, border: "none", color: "white",
                        backgroundColor: "#2b7dbd", borderRadius: "7px"
                    }}>
                        <svg xmlns="http://www.w3.org/2000/svg" style={{ height: "25px", color: "white", marginRight: "10px" }} fill="currentColor" viewBox="0 0 512 512"><path d="M511.2 387l-23.25 100.8c-3.266 14.25-15.79 24.22-30.46 24.22C205.2 512 0 306.8 0 54.5c0-14.66 9.969-27.2 24.22-30.45l100.8-23.25C139.7-2.602 154.7 5.018 160.8 18.92l46.52 108.5c5.438 12.78 1.77 27.67-8.98 36.45L144.5 207.1c33.98 69.22 90.26 125.5 159.5 159.5l44.08-53.8c8.688-10.78 23.69-14.51 36.47-8.975l108.5 46.51C506.1 357.2 514.6 372.4 511.2 387z" /></svg>
                        07314821589</div>}
                </div>
            </div> */}
            <div style={{ height: "80px" }}>
                <div className={window.innerWidth > 700 ? "text-start" : "ps-3 pe-3 text-start"} style={{ position: "fixed", zIndex: 1, paddingTop: "10px", width: "100vw", borderBottom: "1px solid grey", backgroundColor: "white" }}>
                    <Row>
                        <Col className="offset-lg-1 col-lg-2">
                            <img className="mb-3" height="40" alt="" src="https://i0.wp.com/care24.co.in/wp-content/uploads/2022/07/care24-logo.png?fit=576%2C139&ssl=1"></img>
                        </Col>
                        <Col className="offset-lg-4 col-lg-4">
                            {/* {window.innerWidth < 700 && <a href="tel:7314821589" style={{
                                float: 'right',
                                padding: "10px",
                                border: "none", color: "white",
                                backgroundColor: "#2b7dbd", borderRadius: "7px"
                            }}><svg xmlns="http://www.w3.org/2000/svg" style={{ height: "25px", color: "white", }} fill="currentColor" viewBox="0 0 512 512"><path d="M511.2 387l-23.25 100.8c-3.266 14.25-15.79 24.22-30.46 24.22C205.2 512 0 306.8 0 54.5c0-14.66 9.969-27.2 24.22-30.45l100.8-23.25C139.7-2.602 154.7 5.018 160.8 18.92l46.52 108.5c5.438 12.78 1.77 27.67-8.98 36.45L144.5 207.1c33.98 69.22 90.26 125.5 159.5 159.5l44.08-53.8c8.688-10.78 23.69-14.51 36.47-8.975l108.5 46.51C506.1 357.2 514.6 372.4 511.2 387z" /></svg>
                            </a>}
                            {window.innerWidth > 700 && <div style={{
                                float: 'right',
                                padding: "10px",
                                fontWeight: "bold",
                                fontSize: "19px",
                                width: window.innerWidth > 700 ? "395" : window.innerWidth, border: "none", color: "white",
                                backgroundColor: "#2b7dbd", borderRadius: "7px"
                            }}>
                                Call Now :
                                07314821589</div>} */}
                        </Col>
                    </Row>
                </div>
            </div>
        </>
    );
}

export default Header